import { useEffect, useState } from 'react'
import { cn } from '@/lib/utils'

export function Rain() {
  const [drops, setDrops] = useState<Array<{ id: number; style: React.CSSProperties }>>([])

  useEffect(() => {
    const newDrops = Array.from({ length: 100 }, (_, i) => ({
      id: i,
      style: {
        left: `${Math.random() * 100}%`,
        animationDuration: `${0.4 + Math.random() * 0.4}s`,
        animationDelay: `${Math.random() * 2}s`,
      },
    }))
    setDrops(newDrops)
  }, [])

  return (
    <div className="absolute inset-0 pointer-events-none overflow-hidden z-0">
      {drops.map((drop) => (
        <div
          key={drop.id}
          className="absolute bg-white/40 w-[2px] h-[20px] animate-rain"
          style={drop.style}
        />
      ))}
    </div>
  )
}
